import type { CSSProperties } from 'react';
import { NavLink } from 'react-router-dom';

/**
 * Top-level navigation tabs for every page under /payroll/*. Uses the
 * tab-bar-wrapper pattern from .claude/skills/ui-ux-admin/SKILL.md §3 —
 * horizontal scroll with edge-fade on mobile.
 */

const TABS = [
  { to: '/payroll/run', label: 'Pay run' },
  { to: '/payroll/settings', label: 'Settings & mapping' },
  { to: '/payroll/leave', label: 'Leave' },
];

function tabStyle(active: boolean): CSSProperties {
  return {
    padding: 'var(--spacing-2) var(--spacing-4)',
    borderBottom: active ? '2px solid var(--color-accent)' : '2px solid transparent',
    backgroundColor: 'transparent',
    color: active ? 'var(--color-accent)' : 'var(--color-text-muted)',
    fontWeight: active ? 600 : 400,
    fontSize: 'var(--font-size-sm)',
    textDecoration: 'none',
    flexShrink: 0,
    minHeight: 44, // touch target — ui-ux-admin §1.2
    display: 'inline-flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
  };
}

export function PayrollTabs() {
  return (
    <div
      className="tab-bar-wrapper"
      style={{
        borderBottom: '1px solid var(--color-border)',
        marginBottom: 'var(--spacing-4)',
      }}
    >
      <div
        className="tab-bar"
        style={{
          display: 'flex',
          gap: 'var(--spacing-1)',
          overflowX: 'auto',
          flexWrap: 'nowrap',
          WebkitOverflowScrolling: 'touch',
          scrollbarWidth: 'none',
        }}
      >
        {TABS.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            style={({ isActive }) => tabStyle(isActive)}
            className={({ isActive }) => (isActive ? 'tab-active' : undefined)}
          >
            {t.label}
          </NavLink>
        ))}
      </div>
    </div>
  );
}
